
export default class Album {

	static getHolderSelectors = () => ['.album-element'];

	/** @type {HTMLElement} */
	#holderElement;

	/** @param {HTMLElement} holderElement */
	constructor(holderElement) {
		this.#holderElement = holderElement;
		let self = this;
		let lastWindowSize = window.innerWidth;

		this.#resizeSlider();
		self.#holderElement.querySelector('.splide__track').style.maxHeight = (self.#holderElement.querySelector('.splide__slide').querySelector('img').offsetHeight - 1)/16 + 'rem';

		window.addEventListener('resize', function(event) {
			if ((lastWindowSize < 768 && window.innerWidth >= 768) || (lastWindowSize >= 768 && window.innerWidth < 768)) {
				lastWindowSize = window.innerWidth;
				self.#resizeSlider();
			}
			self.#holderElement.querySelector('.splide__track').style.maxHeight = (self.#holderElement.querySelector('.splide__slide').querySelector('img').offsetHeight - 1)/16 + 'rem';
		}, true);
	}

	#resizeSlider() {
		let splide;
		let self = this;

		if (window.innerWidth < 768) {
			splide = new Splide(this.#holderElement.querySelector('.splide'), {
				// type: 'slide',
				// rewind: true,
				// rewindByDrag: true,
				perPage: 1,
				perMove: 1,
				arrows: true,
				pagination: false,
				// paginationDirection: 'ltr',
				drag: true,
			}).mount();
		} else {
			// Remove duplicate dots when resizing window
			if (this.#holderElement.querySelector('.splide__pagination')) {
				this.#holderElement.querySelector('.splide__pagination').innerHTML = '';
			}

			splide = new Splide(this.#holderElement.querySelector('.splide'), {
				// type: 'slide',
				// rewind: true,
				// rewindByDrag: true,
				perPage: 1,
				perMove: 1,
				arrows: true,
				pagination: false,
				// paginationDirection: 'ltr',
				drag: true,
			}).mount();
		}

		this.#holderElement.querySelectorAll('.category').forEach(category => {
			category.addEventListener("click", ()=>{
				this.#holderElement.querySelector('.filter-tab').querySelector('.is-active')?.classList.remove('is-active');
				category.classList.add('is-active');

				let splideId = this.#holderElement.querySelector('.splide')?.querySelector(`.${category.dataset.category}`)?.getAttribute('id');
				if (splideId) {
					splide.go(parseInt(splideId.split('slide')[1]) - 1);
				}
			});
		});

		splide.on( 'active', function () {
			let activeCategory = self.#holderElement.querySelector('.splide__track')?.querySelector('.is-active')?.dataset.category.split(' ')[0];
			self.#holderElement.querySelector('.filter-tab').querySelector('.is-active')?.classList.remove('is-active');
			self.#holderElement.querySelector('.filter-tab').querySelector(`.${activeCategory}`)?.classList.add('is-active');
		} );
	}

}
